export default "__VITE_ASSET__DMzjVLKE__"